/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Image } from 'antd-v5';
import './styles.scss';

const NOT_FOUND_IMAGE = 'https://dashboard-v2-images.s3.amazonaws.com/not-found.png';

const Carousel = props => {
  const { images, isClientPage, getImageUrl } = props;

  const [failedUrls, setFailedUrls] = useState(new Set());

  useEffect(() => {
    setFailedUrls(new Set());
  }, [images]);

  if (!images.length) {
    return <Image src={NOT_FOUND_IMAGE} fallback={NOT_FOUND_IMAGE} alt="Product" />;
  }

  const primaryImage = useMemo(() => images.find(image => image.isPrimary) || images[0], [images]);

  const firstWorkingImage = useMemo(() => {
    if (primaryImage?.url && !failedUrls.has(primaryImage.url)) {
      return primaryImage;
    }
    return images.find(image => image.url && !failedUrls.has(image.url)) || primaryImage;
  }, [images, failedUrls, primaryImage]);

  const [selectedImage, setSelectedImage] = useState(primaryImage);

  useEffect(() => {
    setSelectedImage(firstWorkingImage);
    getImageUrl(firstWorkingImage?.url || NOT_FOUND_IMAGE);
  }, [firstWorkingImage]);

  const handleSelectImage = image => {
    setSelectedImage(image);
    getImageUrl(image.url || NOT_FOUND_IMAGE);
  };

  const handleImageError = useCallback(
    url => {
      if (url) {
        setFailedUrls(prev => new Set(prev).add(url));
      }
    },
    [],
  );

  return (
    <div className="cb-carousel">
      <div className={`cb-carousel__preview${isClientPage ? '-client-page' : ''}`}>
        <Image
          src={selectedImage.url || NOT_FOUND_IMAGE}
          fallback={NOT_FOUND_IMAGE}
          alt="Product"
          onError={() => handleImageError(selectedImage.url)}
        />
      </div>

      <div className="cb-carousel__track">
        {images.map((image, index) => (
          <Image
            key={`${image.url}-${index}`}
            src={image.url || NOT_FOUND_IMAGE}
            fallback={NOT_FOUND_IMAGE}
            preview={false}
            onClick={() => handleSelectImage(image)}
            onError={() => handleImageError(image.url)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
